<template>
  <h4>
    <label class="header-label" @click="updateValue(!value)">
      <slot></slot>
    </label>
    <span class="switch">
      <i
        v-if="value === true"
        class="fa fa-toggle-on"
        aria-hidden="true"
        @click="updateValue(false)"
      ></i>
      <i v-else class="fa fa-toggle-off c5" aria-hidden="true" @click="updateValue(true)"></i>
    </span>
  </h4>
</template>
<script>
export default {
  name: "character-sheet-shared-toggle-header",
  props: ["id", "value"],
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../../assets/_global";

h4 {
  margin-top: -0.25em;
  margin-bottom: 1em !important;
  font-family: inherit;
  border-bottom: solid 2px $gray-400;
  // color: $gray-400;
  font-size: 1rem;
  line-height: 1rem;
  .switch {
    float: right !important;
    padding-top: 0.325em;
  }
}
.header-label {
  cursor: pointer;
  line-height: 1;
  font-size: 1rem;
  width: 90%;
}
.switch {
  cursor: pointer;
  font-size: 1.25em;
  // background-color: $body-bg;
}
</style>
